import style from '../style.css';

export default () => (<div className={style.flexContent} />);
